import React, { useState } from "react";

const Formulario = () => {
    const [seleccionado, setSeleccionado] = useState("");
    const [step, setStep] = useState(1);
    const [nivel, setNivel] = useState("");
    const [contratista, setContratista] = useState("");
    const [profesion, setProfesion] = useState("");
    const [otraProfesion, setOtraProfesion] = useState("");
    const [contrato, setContrato] = useState("");
    const [sector, setSector] = useState("");
    const [ocupacion, setOcupacion] = useState("");
    const [ciiu, setCiiu] = useState("");
    const [tipoPension, setTipoPension] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [pais, setPais] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [direccion, setDireccion] = useState("");
    const [direccionResidencia, setDireccionResidencia] = useState("");
    const [cargo, setCargo] = useState("");
    const [fechaDia, setFechaDia] = useState("");
    const [fechaMes, setFechaMes] = useState("");
    const [fechaAnio, setFechaAnio] = useState("");
    const [aniosActividad, setAniosActividad] = useState("");
    const [telefono, setTelefono] = useState("");
    const niveles = ["Ninguno", "Primaria", "Bachillerato", "Técnico", "Tecnólogo", "Pregrado", "Posgrado"];
    const [estadoCivil, setEstadoCivil] = useState("");
    const [personasCargo, setPersonasCargo] = useState("");
    const [hijos, setHijos] = useState("");
    const [nombreConyuge, setNombreConyuge] = useState("");
    const [apellidoConyuge, setApellidoConyuge] = useState("");
    const [paisNacimiento, setPaisNacimiento] = useState("");
    const [paisExpedicion, setPaisExpedicion] = useState("");
    const [tipoDoc, setTipoDoc] = useState('');
    const [docConyuge, setDocConyuge] = useState('');
    const [ocupacionConyuge, setOcupacionConyuge] = useState('');
    const [correoConyuge, setCorreoConyuge] = useState('');
    const [celularConyuge, setCelularConyuge] = useState('');


    const [genero, setGenero] = useState("");
    const [primerNombre, setPrimerNombre] = useState("");
    const [segundoNombre, setSegundoNombre] = useState("");
    const [primerApellido, setPrimerApellido] = useState("");
    const [segundoApellido, setSegundoApellido] = useState("");
    const [dia, setDia] = useState("");
    const [mes, setMes] = useState("");
    const [anio, setAnio] = useState("");
    const [celular, setCelular] = useState("");
    const [telefonoFijo, setTelefonoFijo] = useState("");
    const [correo, setCorreo] = useState("");

    // Estos seguro ya los tienes pero igual te los dejo
    const [nacimientoColombia, setNacimientoColombia] = useState("");
    const [departamento, setDepartamento] = useState("");

    const [nacionalidad, setNacionalidad] = useState("");
    const [otraNacionalidad, setOtraNacionalidad] = useState("");
    const [otraNacionalidadPais, setOtraNacionalidadPais] = useState("");
    const [vivesEnColombia, setVivesEnColombia] = useState("");
    const [estrato, setEstrato] = useState("");
    const [ciudadVive, setCiudadVive] = useState("");
    const [paisVive, setPaisVive] = useState("");
    const [pep, setPep] = useState("");
    const [riesgo, setRiesgo] = useState("");




    const opciones = [
        "Cédula de Ciudadanía",
        "Cédula de Extranjería",
        "Pasaporte",
        "Permiso Especial de Permanencia",
        "Tarjeta de Identidad",
        "NUIP",
        "Carné Diplomático",
        "Nacional CAN o DNI"
    ];

    const dias = Array.from({ length: 31 }, (_, i) => i + 1);
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const anios = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);

    const departamentos = ["Amazonas", "Antioquia", "Arauca", "Atlántico", "Bogotá D.C.", "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda", "San Andrés y Providencia", "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"];
    const ciudades = ["Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Cúcuta", "Bucaramanga", "Pereira", "Santa Marta", "Ibagué", "Villavicencio", "Manizales", "Neiva", "Armenia", "Pasto", "Montería"];

    return (
        <div className="bg-[#e8f2f4] p-4 rounded-3xl space-y-4 w-full">
            <div className="flex items-center justify-between mb-2">
                {step !== 1 ? (
                    <button onClick={() => setStep(step - 1)} className="flex items-center space-x-2 text-[#0054c9] font-bold text-base drop-shadow">
                        <span className="text-xl">←</span>
                        <span>Paso {step - 1}</span>
                    </button>
                ) : <div />}
                <span className="text-[#0054c9] font-bold text-base drop-shadow">Completado: {Math.round(((step - 1) / 6) * 100)}%</span>
            </div>
            {step === 1 && (
                <div className="space-y-1">
                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál de estas opciones te queda mejor?</p>
                    {["Señora", "Señor"].map((op) => (
                        <button key={op} onClick={() => setGenero(op)} className={`w-full text-left p-2 rounded ${genero === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>{op}</button>
                    ))}
                    <div className="space-y-4 mt-6">
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Primer nombre</p>
                        <input value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Juanito" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Segundo nombre</p>
                        <input value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Pepito" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Primer apellido</p>
                        <input value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Perez" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Segundo apellido</p>
                        <input value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Mora" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Fecha de nacimiento</p>
                        <div className="flex space-x-2">
                            <select value={dia} onChange={(e) => setDia(e.target.value)} className="w-1/3 bg-[#cce0ff] p-2 rounded">
                                <option>Día</option>
                                {[...Array(31)].map((_, i) => <option key={i + 1}>{i + 1}</option>)}
                            </select>
                            <select value={mes} onChange={(e) => setMes(e.target.value)} className="w-1/3 bg-[#cce0ff] p-2 rounded">
                                <option>Mes</option>
                                {["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"].map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
                            </select>
                            <select value={anio} onChange={(e) => setAnio(e.target.value)} className="w-1/3 bg-[#cce0ff] p-2 rounded">
                                <option>Año</option>
                                {[...Array(100)].map((_, i) => <option key={i}>{2025 - i}</option>)}
                            </select>
                        </div>
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Escribe tu número de celular</p>
                        <input value={celular} onChange={(e) => setCelular(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 3234858321" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Teléfono fijo</p>
                        <input value={telefonoFijo} onChange={(e) => setTelefonoFijo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 7185188" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow">Correo electrónico</p>
                        <input value={correo} onChange={(e) => setCorreo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: micorreo@ejemplo.com" />
                        <p className="text-[#0054c9] font-bold text-base drop-shadow mb-2">¿Naciste en Colombia?</p>
                        <div className="space-y-1 flex flex-col">
                            <button onClick={() => setNacimientoColombia("Si")} className={`w-full text-left p-2 rounded ${nacimientoColombia === "Si" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>Si</button>
                            <button onClick={() => setNacimientoColombia("No")} className={`w-full text-left p-2 rounded ${nacimientoColombia === "No" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>No</button>
                        </div>


                        {nacimientoColombia === "Si" && (
                            <>
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">Departamento donde naciste</p>
                                <input value={departamento} onChange={(e) => setDepartamento(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Antioquia" />
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">Ciudad donde naciste</p>
                                <input value={ciudad} onChange={(e) => setCiudad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Medellín" />
                            </>
                        )}
                        {nacimientoColombia === "No" && (
                            <>
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">País donde naciste</p>
                                <input value={pais} onChange={(e) => setPais(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Argentina" />
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">Ciudad donde naciste</p>
                                <input value={ciudad} onChange={(e) => setCiudad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Buenos Aires" />
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Posees la nacionalidad de {pais || '...'}?</p>
                                {["Si", "No"].map((op) => (
                                    <button key={op} onClick={() => setNacionalidad(op)} className={`w-full text-left p-2 rounded ${nacionalidad === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>{op}</button>
                                ))}
                            </>
                        )}
                        <p className="text-[#0054c9] font-bold text-base drop-shadow mb-2">¿Tienes otra nacionalidad?</p>
                        <div className="space-y-1 flex flex-col">
                            <button onClick={() => setOtraNacionalidad("Si")} className={`w-full text-left p-2 rounded ${otraNacionalidad === "Si" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>Si</button>
                            <button onClick={() => setOtraNacionalidad("No")} className={`w-full text-left p-2 rounded ${otraNacionalidad === "No" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>No</button>
                        </div>


                        {otraNacionalidad === "Si" && (
                            <>
                                <p className="text-[#0054c9] font-bold text-base drop-shadow">País de la otra nacionalidad</p>
                                <input value={otraNacionalidadPais} onChange={(e) => setOtraNacionalidadPais(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: España" />
                            </>
                        )}
                        <button onClick={() => setStep(step + 1)} className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Siguiente</button>
                    </div>
                </div>
            )}

            {step === 2 && (
                <div className="space-y-4">
                    <p className="text-[#0054c9] font-bold text-base drop-shadow mb-2">¿Vives en Colombia?</p>
                    <div className="space-y-1 flex flex-col">
                        <button onClick={() => setVivesEnColombia("Si")} className={`w-full text-left p-2 rounded ${vivesEnColombia === "Si" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>Si</button>
                        <button onClick={() => setVivesEnColombia("No")} className={`w-full text-left p-2 rounded ${vivesEnColombia === "No" ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>No</button>
                    </div>

                    {vivesEnColombia === "Si" && (
                        <>
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿A qué estrato socioeconómico pertenece tu vivienda?</p>
                            <select value={estrato} onChange={(e) => setEstrato(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded">
                                <option value="">Selecciona estrato</option>
                                {[1, 2, 3, 4, 5, 6].map((n) => (
                                    <option key={n} value={n}>Estrato {n}</option>
                                ))}
                            </select>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué ciudad o municipio vives actualmente?</p>
                            <select value={ciudadVive} onChange={(e) => setCiudadVive(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded">
                                <option value="">Selecciona ciudad</option>
                                <option>Bogotá</option>
                                <option>Medellín</option>
                                <option>Cali</option>
                                <option>Barranquilla</option>
                                <option>Otra</option>
                            </select>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Dirección exacta de tu residencia</p>
                            <input value={direccionResidencia} onChange={(e) => setDireccionResidencia(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Calle 123 #45-67" />

                        </>
                    )}

                    {vivesEnColombia === "No" && (
                        <>
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">País</p>
                            <select value={paisVive} onChange={(e) => setPaisVive(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded">
                                <option value="">Selecciona país</option>
                                <option>Argentina</option>
                                <option>Chile</option>
                                <option>Perú</option>
                                <option>España</option>
                                <option>Otro</option>
                            </select>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Ciudad</p>
                            <select value={ciudadVive} onChange={(e) => setCiudadVive(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded">
                                <option value="">Selecciona ciudad</option>
                                <option>Ciudad de México</option>
                                <option>Santiago</option>
                                <option>Buenos Aires</option>
                                <option>Madrid</option>
                                <option>Otra</option>
                            </select>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Dirección exacta de tu residencia</p>
                            <input value={direccionResidencia} onChange={(e) => setDireccionResidencia(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Calle 123 #45-67" />
                        </>
                    )}
                    <button onClick={() => setStep(step + 1)} className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Siguiente</button>

                </div>
            )}


            {step === 3 && (
                <>
                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-2 drop-shadow">¿Cuál es el tipo de tu documento de identidad?</p>
                        <div className="space-y-1">
                            {opciones.map((opcion) => (
                                <button
                                    key={opcion}
                                    onClick={() => setSeleccionado(opcion)}
                                    className={`w-full text-left p-2 rounded ${seleccionado === opcion ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                                >
                                    {opcion}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">¿Cuál es el número de tu documento de identidad?</p>
                        <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 1023456789" />
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">¿Cuál es la fecha de expedición de tu documento?</p>
                        <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 12/08/2015" />
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">Fecha de nacimiento</p>
                        <div className="flex space-x-2">
                            <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                <option>Día</option>
                                {dias.map((dia) => <option key={dia}>{dia}</option>)}
                            </select>
                            <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                <option>Mes</option>
                                {meses.map((mes) => <option key={mes}>{mes}</option>)}
                            </select>
                            <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                <option>Año</option>
                                {anios.map((anio) => <option key={anio}>{anio}</option>)}
                            </select>
                        </div>
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">¿En qué país fue expedido tu documento?</p>
                        <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Colombia" />
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">¿En qué departamento fue expedido?</p>
                        <select className="w-full bg-[#cce0ff] p-2 rounded">
                            <option>Selecciona</option>
                            {departamentos.map((dpto) => <option key={dpto}>{dpto}</option>)}
                        </select>
                    </div>

                    <div>
                        <p className="text-[#0054c9] font-bold text-base mb-1 drop-shadow">¿En qué ciudad fue expedido?</p>
                        <select className="w-full bg-[#cce0ff] p-2 rounded">
                            <option>Selecciona</option>
                            {ciudades.map((ciudad) => <option key={ciudad}>{ciudad}</option>)}
                        </select>
                    </div>

                    <button onClick={() => setStep(step + 1)} className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Siguiente</button>

                </>
            )}
            {step === 4 && (
                <>

                    {/* Segundo formulario */}
                    <p className="text-[#0054c9] font-bold text-base mb-2 drop-shadow">¿Cuál es tu nivel de estudios?</p>
                    <div className="space-y-1">
                        {niveles.map((op) => (
                            <button
                                key={op}
                                onClick={() => setNivel(op)}
                                className={`w-full text-left p-2 rounded ${nivel === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                            >
                                {op}
                            </button>
                        ))}
                    </div>

                    <p className="text-[#0054c9] font-bold text-base mb-2 drop-shadow mt-4">¿Cuál es tu profesión?</p>
                    <select
                        className="w-full bg-[#cce0ff] p-2 rounded"
                        value={profesion}
                        onChange={(e) => setProfesion(e.target.value)}
                    >
                        <option>Selecciona</option>
                        <option>Ingeniero</option>
                        <option>Doctor</option>
                        <option>Abogado</option>
                        <option>Profesor</option>
                        <option>Otro</option>
                    </select>

                    {profesion === "Otro" && (
                        <input
                            type="text"
                            placeholder="Especifica tu profesión"
                            className="w-full bg-[#cce0ff] p-2 rounded mt-2"
                            value={otraProfesion}
                            onChange={(e) => setOtraProfesion(e.target.value)}
                        />
                    )}

                    <p className="text-[#0054c9] font-bold text-base drop-shadow mt-4">¿Cómo describes tu perfil de riesgo al invertir?</p>
                    <div className="space-y-1">
                        {["Conservador", "Moderado", "Arriesgado"].map((op) => (
                            <button
                                key={op}
                                onClick={() => setRiesgo(op)}
                                className={`w-full text-left p-2 rounded ${riesgo === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                            >
                                {op}
                            </button>
                        ))}
                    </div>


                    <button onClick={() => setStep(step + 1)} className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Siguiente</button>

                </>
            )}
            {step === 5 && (
                <>
                    <p className="text-[#0054c9] font-bold text-base mb-2 drop-shadow">¿Eres contratista del Estado?</p>
                    <div className="space-y-1">
                        {["Si", "No"].map((op) => (
                            <button
                                key={op}
                                onClick={() => setContratista(op)}
                                className={`w-full text-left p-2 rounded ${contratista === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                            >
                                {op}
                            </button>
                        ))}
                    </div>

                    <p className="text-[#0054c9] font-bold text-base mb-2 drop-shadow mt-4">¿Cuál es tu ocupación actual?</p>
                    <div className="space-y-1">
                        {["Empleado", "Independiente", "Pensionado", "Ama de casa", "Estudiante", "Desempleado con ingresos", "Desempleado sin ingresos"].map((op) => (
                            <button
                                key={op}
                                onClick={() => setProfesion(op)}
                                className={`w-full text-left p-2 rounded ${profesion === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                            >
                                {op}
                            </button>
                        ))}
                    </div>

                    {/* Si es empleado */}
                    {profesion === "Empleado" && (
                        <div className="space-y-4 mt-6">
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cómo se llama la empresa para la que trabajas?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Nombre de la empresa" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué país está ubicada la empresa donde trabajas?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="País" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué ciudad está ubicada la empresa donde trabajas?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ciudad" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos la dirección de la empresa</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Dirección" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es tu cargo en la empresa?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Cargo" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué fecha comenzaste a trabajar en la empresa? (aproximado)</p>
                            <div className="flex space-x-2">
                                <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                    <option>Día</option>
                                    {/* opciones día */}
                                </select>
                                <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                    <option>Mes</option>
                                    {/* opciones mes */}
                                </select>
                                <select className="bg-[#cce0ff] p-2 rounded w-1/3">
                                    <option>Año</option>
                                    {/* opciones año */}
                                </select>
                            </div>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántos años llevas desempeñando esta actividad?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Años" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Qué tipo de contrato laboral tienes?</p>
                            <div className="space-y-1">
                                {["Fijo", "Indefinido"].map((op) => (
                                    <button
                                        key={op}
                                        onClick={() => setContrato(op)}
                                        className={`w-full text-left p-2 rounded ${contrato === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                                    >
                                        {op}
                                    </button>
                                ))}
                            </div>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el sector económico al que tu empresa pertenece?</p>
                            <div className="space-y-1">
                                {["Comercio", "Producción", "Servicios"].map((op) => (
                                    <button
                                        key={op}
                                        onClick={() => setSector(op)}
                                        className={`w-full text-left p-2 rounded ${sector === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                                    >
                                        {op}
                                    </button>
                                ))}
                            </div>

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el NIT de la empresa?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="NIT de la empresa" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el correo electrónico de la empresa?</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Correo electrónico" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Dinos un teléfono o celular de contacto de la empresa</p>
                            <input className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Teléfono o celular" />
                        </div>
                    )}
                    {profesion === "Independiente" && (
                        <div className="space-y-4 mt-6">
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el código CIIU de tu actividad económica?</p>
                            <select value={ciiu} onChange={(e) => setCiiu(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded">
                                <option value="">Selecciona un código CIIU</option>
                                <option value="6201">6201 - Desarrollo de software</option>
                                <option value="4711">4711 - Comercio al por menor</option>
                                <option value="5611">5611 - Restaurantes y servicios de comida</option>
                                <option value="7020">7020 - Actividades de consultoría de gestión</option>
                                <option value="7490">7490 - Otras actividades profesionales, científicas y técnicas</option>
                            </select>


                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos cuál de las siguientes opciones se ajusta a tu ocupación actual</p>
                            <div className="space-y-1">
                                {[
                                    "Tienes un contrato por prestación de servicios",
                                    "Ofreces algún producto o servicio y tienes empresa constituida",
                                    "No tengo empresa constituida"
                                ].map((op) => (
                                    <button
                                        key={op}
                                        onClick={() => setOcupacion(op)}
                                        className={`w-full text-left p-2 rounded ${ocupacion === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                                    >
                                        {op}
                                    </button>
                                ))}
                            </div>


                            {ocupacion === "Tienes un contrato por prestación de servicios" && (
                                <div className="space-y-4 mt-6">
                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cómo se llama la empresa para la que trabajas?</p>
                                    <input value={empresa} onChange={(e) => setEmpresa(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Nombre de la empresa" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué país está ubicada la empresa donde trabajas?</p>
                                    <input value={pais} onChange={(e) => setPais(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="País" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué ciudad está ubicada la empresa donde trabajas?</p>
                                    <input value={ciudad} onChange={(e) => setCiudad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ciudad" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos la dirección de la empresa</p>
                                    <input value={direccion} onChange={(e) => setDireccion(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Dirección" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es tu cargo en la empresa?</p>
                                    <input value={cargo} onChange={(e) => setCargo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Cargo" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué fecha comenzaste a trabajar en la empresa? (aproximado)</p>
                                    <div className="flex space-x-2">
                                        <select value={fechaDia} onChange={(e) => setFechaDia(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Día</option>
                                            {[...Array(31)].map((_, i) => <option key={i}>{i + 1}</option>)}
                                        </select>
                                        <select value={fechaMes} onChange={(e) => setFechaMes(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Mes</option>
                                            {["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"].map((mes, i) => <option key={i}>{mes}</option>)}
                                        </select>
                                        <select value={fechaAnio} onChange={(e) => setFechaAnio(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Año</option>
                                            {[...Array(50)].map((_, i) => <option key={i}>{2025 - i}</option>)}
                                        </select>
                                    </div>

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántos años llevas desempeñando esta actividad?</p>
                                    <input value={aniosActividad} onChange={(e) => setAniosActividad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Años" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">Dinos un teléfono o celular de contacto de la empresa</p>
                                    <input value={telefono} onChange={(e) => setTelefono(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Teléfono o celular" />
                                </div>
                            )}
                            {ocupacion === "Ofreces algún producto o servicio y tienes empresa constituida" && (
                                <div className="space-y-4 mt-6">
                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cómo se llama tu empresa?*</p>
                                    <input value={empresa} onChange={(e) => setEmpresa(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Soluciones Tech S.A.S" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué país está ubicada tu empresa?*</p>
                                    <input value={pais} onChange={(e) => setPais(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Colombia" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué ciudad está ubicada tu empresa?*</p>
                                    <input value={ciudad} onChange={(e) => setCiudad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Bogotá" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos la dirección de tu empresa*</p>
                                    <input value={direccion} onChange={(e) => setDireccion(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Calle 123 #45-67" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué fecha constituiste la empresa?*</p>
                                    <div className="flex space-x-2">
                                        <select value={fechaDia} onChange={(e) => setFechaDia(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Día</option>
                                            {[...Array(31)].map((_, i) => <option key={i}>{i + 1}</option>)}
                                        </select>
                                        <select value={fechaMes} onChange={(e) => setFechaMes(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Mes</option>
                                            {["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"].map((mes, i) => <option key={i}>{mes}</option>)}
                                        </select>
                                        <select value={fechaAnio} onChange={(e) => setFechaAnio(e.target.value)} className="bg-[#cce0ff] p-2 rounded w-1/3">
                                            <option>Año</option>
                                            {[...Array(50)].map((_, i) => <option key={i}>{2025 - i}</option>)}
                                        </select>
                                    </div>

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántos años llevas desempeñando esta actividad?*</p>
                                    <input value={aniosActividad} onChange={(e) => setAniosActividad(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 5 años" />

                                    <p className="text-[#0054c9] font-bold text-base drop-shadow">Dinos un teléfono o celular de contacto de la empresa</p>
                                    <input value={telefono} onChange={(e) => setTelefono(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: +57 310 000 0000" />
                                </div>
                            )}

                        </div>
                    )}
                    {profesion === "Pensionado" && (
                        <div className="space-y-4 mt-6">
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos la empresa donde te pensionaste*</p>
                            <input value={empresa} onChange={(e) => setEmpresa(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Empresa ABC" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál fue tu último cargo que desempeñaste en la empresa?*</p>
                            <input value={cargo} onChange={(e) => setCargo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Jefe de operaciones" />

                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Tipo de pensión*</p>
                            <div className="space-y-1">
                                {["Vejez", "Invalidez", "Sobrevivencia"].map((op) => (
                                    <button
                                        key={op}
                                        onClick={() => setTipoPension(op)}
                                        className={`w-full text-left p-2 rounded ${tipoPension === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                                    >
                                        {op}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <button onClick={() => setStep(step + 1)} className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Siguiente</button>

                </>
            )}
            {step === 6 && (
                <div className="space-y-1">
                    <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos, ¿Cuál es tu estado civil?</p>
                    {["Soltero", "Casado", "Unión libre", "Divorciado", "Viudo", "Religioso"].map((op) => (
                        <button key={op} onClick={() => setEstadoCivil(op)} className={`w-full text-left p-2 rounded ${estadoCivil === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>{op}</button>
                    ))}
                    {estadoCivil === "Casado" && (
                        <div className="space-y-4 mt-6">
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Indícanos el primer nombre de tu cónyuge*</p>
                            <input value={nombreConyuge} onChange={(e) => setNombreConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Juan" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el primer apellido de tu cónyuge?*</p>
                            <input value={apellidoConyuge} onChange={(e) => setApellidoConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Pérez" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué país nació tu cónyuge?*</p>
                            <input value={paisNacimiento} onChange={(e) => setPaisNacimiento(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Colombia" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿En qué país fue expedido su documento?*</p>
                            <input value={paisExpedicion} onChange={(e) => setPaisExpedicion(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Colombia" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es el tipo de su documento de identidad?*</p>
                            <div className="space-y-1">
                                {["Cédula de Ciudadanía", "Cédula de Extranjería", "Pasaporte", "Permiso Especial de Permanencia", "Tarjeta de Identidad", "NUIP", "Carné Diplomático", "Nacional CAN o DNI"].map((op) => (
                                    <button key={op} onClick={() => setTipoDoc(op)} className={`w-full text-left p-2 rounded ${tipoDoc === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}>{op}</button>
                                ))}
                            </div>
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Número de identificación de tu cónyuge*</p>
                            <input value={docConyuge} onChange={(e) => setDocConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 123456789" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuál es la ocupación u oficio de tu cónyuge?*</p>
                            <input value={ocupacionConyuge} onChange={(e) => setOcupacionConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: Contador" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Correo electrónico de tu cónyuge*</p>
                            <input value={correoConyuge} onChange={(e) => setCorreoConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: correo@ejemplo.com" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">Número de celular de tu cónyuge*</p>
                            <input value={celularConyuge} onChange={(e) => setCelularConyuge(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: +57 300 123 4567" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántas personas a cargo tienes?*</p>
                            <p className="text-sm text-[#0054c9] drop-shadow">• Hijos legítimos, naturales, adoptivos e hijastros hasta los 18 años que cumplan los requisitos de escolaridad.<br />• Hermanos huérfanos de padres, dependientes del trabajador, hasta los 18 años que cumplan con los requisitos de escolaridad.<br />• Sin límite de edad, cuando sean inválidos o de capacidad física disminuida que les impida trabajar.</p>
                            <input value={personasCargo} onChange={(e) => setPersonasCargo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 3" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántos hijos tienes?*</p>
                            <input value={hijos} onChange={(e) => setHijos(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 2" />
                        </div>
                    )}
                    {estadoCivil === "Soltero" && (
                        <div className="space-y-4 mt-6">
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántas personas a cargo tienes?*</p>
                            <p className="text-sm text-[#0054c9] drop-shadow">• Hijos legítimos, naturales, adoptivos e hijastros hasta los 18 años que cumplan los requisitos de escolaridad.<br />• Hermanos huérfanos de padres, dependientes del trabajador, hasta los 18 años que cumplan con los requisitos de escolaridad.<br />• Sin límite de edad, cuando sean inválidos o de capacidad física disminuida que les impida trabajar.</p>
                            <input value={personasCargo} onChange={(e) => setPersonasCargo(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 3" />
                            <p className="text-[#0054c9] font-bold text-base drop-shadow">¿Cuántos hijos tienes?*</p>
                            <input value={hijos} onChange={(e) => setHijos(e.target.value)} className="w-full bg-[#cce0ff] p-2 rounded" placeholder="Ej: 2" />
                        </div>
                    )}

                    <p className="text-[#0054c9] font-bold text-base drop-shadow mt-6">¿Eres una Persona Expuesta Políticamente (PEP)?</p>
                    <div className="space-y-1">
                        {["Si", "No"].map((op) => (
                            <button
                                key={op}
                                onClick={() => setPep(op)}
                                className={`w-full text-left p-2 rounded ${pep === op ? 'bg-[#003c91] text-white' : 'bg-[#cce0ff]'}`}
                            >
                                {op}
                            </button>
                        ))}
                    </div>

                    <button className="w-full bg-green-600 text-white font-bold py-2 rounded shadow mt-4">Enviar</button>

                </div>

            )}




        </div>
    );
};

export default Formulario;
